// extracted by mini-css-extract-plugin
export var tabButton = "Tabs-module--tab-button--c767a";
export var tabs = "Tabs-module--tabs--f542b";